import { Cell, CellStatus, CellType } from "@m4a3/api-client";
import { API } from "aws-amplify";
import { WeatherData } from "../models/weather.interface-data";

export const getWeatherForCell = (cell: Cell): Promise<WeatherData> => {
  const mocWeatherData: WeatherData = {
    windDirection: 120,
    windSpeed: 2,
    timestamp: new Date().toISOString()
  }

  if (cell.cellStatus === CellStatus.DECOMMISSIONED || cell.cellType !== CellType.PROD) {
    return Promise.resolve(mocWeatherData);
  }

  return API.get('bom', `/weather/weatherdata/${cell.prefix}`, {})
};
